import { quickTicker } from "@/mocks/news";

export default function BreakingTicker() {
  const loop = [...quickTicker, ...quickTicker];

  return (
    <section aria-label="实时快讯" className="w-full bg-primary-600 text-background-50">
      <div className="w-full flex items-center">
        <div className="shrink-0 flex items-center gap-2 h-11 px-4 md:px-6 bg-primary-700">
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-flashlight-fill text-accent-400"></i>
          </span>
          <span className="text-sm font-medium tracking-wide whitespace-nowrap">实时快讯</span>
        </div>
        <div className="ticker-wrap flex-1 overflow-hidden">
          <div className="ticker-track py-3">
            {loop.map((item, index) => (
              <span key={`${item}-${index}`} className="inline-flex items-center gap-3 px-6 text-sm whitespace-nowrap">
                <span className="w-1.5 h-1.5 rounded-full bg-accent-400"></span>
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}